<template>
  <donut-chart89-template
    :board-ids="[288]"
    :data-type="dataType"
    :graph-id="90"
    date-field="$.body.stdInfo.점검일"
    :count-fields="['body.stdInfo.재해형태']"
    title="현장순회점검 현황"
    unit="건"/>
</template>
<script>
/* eslint-disable brace-style */
import DonutChart89Template from "@/views/graph/DonutChart89Template.vue";

export default {
  name: 'DonutChart90',
  components: {DonutChart89Template},
  props: {
    dataType: 'detail' | 'field' | 'company' | 'project',
  },
}
</script>

<style scoped>

</style>
